import React from 'react';
import '../css/Services.css'

import AnimationPoint from './AnimationPoint'
import WithAnimation from './WithAnimation'

import starfish from '../img/Services/Starfish1_light.svg'
import landingTop from '../img/Landing/Landing-bottom-upsidedown.png'


class ServicesSection extends WithAnimation {
  constructor(props) {
    super(props);
    this.renderService = this.renderService.bind(this)
    this.renderDisplay = this.renderDisplay.bind(this)
    this.renderRightSide = this.renderRightSide.bind(this)
    this.renderLeftSide = this.renderLeftSide.bind(this)

    this.reverse = false;

  }

  componentDidMount() {
    const { side, index } = this.props;

    switch(side) {
      case "Left":
        this.Timeline.from(`#text-${index}`,1,{x: 200, opacity: 0})
        this.backgroundStyleObj = {textAlign: "left", backgroundImage: `url(${starfish})`,"backgroundPosition": " -40% 60%" }
        break;
      case "Right":
        this.Timeline.from(`#text-${index}`,1,{x: -200, opacity: 0})
        this.backgroundStyleObj = {textAlign: "right", backgroundImage: `url(${starfish})`,"backgroundPosition": " 70% 50%" } //70% 60%
        break;
      default:
        break;
    }

  }

  renderRightSide({ title, image, text }) {
    const { animationEnter, animationLeave, backgroundStyleObj, props } = this
    return (
      <div className="services-section">
        <AnimationPoint enter={animationEnter} leave={animationLeave} bottomOffset={100} />
        <div className="row">
          <div className="col-lg-8 text-column" id={`text-${props.index}`} style={backgroundStyleObj}>
            <div className="title" style={{ textAlign: "right" }}><h3>{ title }</h3></div>
            <p>{text}</p>
          </div>
          <div className="col-lg-4 image-column" style={{backgroundImage: `url(${image})`}}></div>
        </div>
      </div>
    )
  }

  renderLeftSide({ title, image, text }) {
    return (
      <div className="services-section">
        <AnimationPoint enter={this.animationEnter} leave={this.animationLeave} bottomOffset={100} />
        <div className="row">
          <div className="col-lg-4 image-column" style={{backgroundImage: `url(${image})`}}>
          </div>
          <div className="col-lg-8 text-column" id={`text-${this.props.index}`} style={this.backgroundStyleObj}>
          <div className="title" style={{ textAlign: "left" }}><h3>{ title }</h3></div>
            <p>{text}</p>
          </div>
        </div>
      </div>
    )
  }

  renderService({ title, image, text, side }) {
    return side === "Left" ? this.renderLeftSide({ title, image, text }) : this.renderRightSide({ title, image, text })
  }

  renderDisplay({ image, top }) {
    return (
      <div className="services-section display" style={{backgroundImage:`linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${image})`}}>
      {top && <div id="landing-top" style={{ backgroundImage: `url(${landingTop})`}}></div>}
      </div>
    )
  }

  render() {
    return this.props.display ? this.renderDisplay(this.props) : this.renderService(this.props)
    
  }
}

export default ServicesSection;



// WEBPACK FOOTER //
// ./src/components/ServicesSection.js